import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { router } from './routes';

function dismissPreloader() {
  const preloader = document.getElementById('preloader');
  if (!preloader) return;
  preloader.classList.add('hidden');
  setTimeout(() => preloader.remove(), 700);
}

function App() {
  useEffect(() => {
    const minDelay = new Promise((r) => setTimeout(r, 1200));
    const loaded = new Promise((r) => {
      if (document.readyState === 'complete') return r();
      window.addEventListener('load', r, { once: true });
    });
    Promise.all([minDelay, loaded]).then(dismissPreloader);
  }, []);

  return (
    <ThemeProvider>
      <div className="min-h-screen">
        <RouterProvider router={router} />
      </div>
    </ThemeProvider>
  );
}

export default App;